/* Tilden – gemensam temalogik. */
(function () {
  'use strict';

  function sidhuvud() {
    var menyknapp = document.querySelector('[data-menyknapp]');
    var nav = document.querySelector('[data-meny]');
    var sokknapp = document.querySelector('[data-sokknapp]');
    var sokfalt = document.querySelector('[data-sokfalt]');

    function stangMeny(aterfokusera) {
      if (!nav || !menyknapp) return;
      nav.classList.remove('oppen');
      menyknapp.setAttribute('aria-expanded', 'false');
      menyknapp.setAttribute('aria-label', 'Öppna meny');
      if (aterfokusera) menyknapp.focus();
    }

    function stangSok(aterfokusera) {
      if (!sokfalt || !sokknapp) return;
      sokfalt.classList.remove('oppen');
      sokknapp.setAttribute('aria-expanded', 'false');
      if (aterfokusera) sokknapp.focus();
    }

    if (menyknapp && nav) {
      menyknapp.addEventListener('click', function () {
        var oppen = nav.classList.toggle('oppen');
        menyknapp.setAttribute('aria-expanded', oppen ? 'true' : 'false');
        menyknapp.setAttribute('aria-label', oppen ? 'Stäng meny' : 'Öppna meny');
        if (oppen) stangSok(false);
      });

      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) stangMeny(false);
      });
    }

    if (sokknapp && sokfalt) {
      sokknapp.addEventListener('click', function () {
        var oppen = sokfalt.classList.toggle('oppen');
        sokknapp.setAttribute('aria-expanded', oppen ? 'true' : 'false');
        if (oppen) {
          stangMeny(false);
          var falt = sokfalt.querySelector('input[type="search"]');
          if (falt) falt.focus();
        }
      });
    }

    document.addEventListener('click', function (e) {
      var sidhuvudet = document.querySelector('.sidhuvud');
      if (!sidhuvudet || sidhuvudet.contains(e.target)) return;
      if (nav && nav.classList.contains('oppen')) stangMeny(false);
      if (sokfalt && sokfalt.classList.contains('oppen')) stangSok(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (nav && nav.classList.contains('oppen')) stangMeny(true);
      else if (sokfalt && sokfalt.classList.contains('oppen')) stangSok(true);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 980) {
        stangMeny(false);
        stangSok(false);
      }
    });
  }

  var aviTimer;
  function avisera(text) {
    var el = document.getElementById('avisering');
    if (!el) return;
    el.textContent = text;
    el.classList.add('syns');
    clearTimeout(aviTimer);
    aviTimer = setTimeout(function () { el.classList.remove('syns'); }, 3000);
  }

  function rot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function uppdateraKorgAntal(antal) {
    document.querySelectorAll('[data-korgantal]').forEach(function (el) { el.textContent = antal; });
  }

  function laggIKorg(form, knapp) {
    var data = new FormData(form);
    knapp.disabled = true;
    var text = knapp.textContent;
    knapp.textContent = 'Lägger till …';
    fetch(rot() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { avisera(res.body.description || 'Produkten kunde inte läggas till.'); return; }
        avisera((res.body.product_title || 'Produkten') + ' lades i varukorgen');
        return fetch(rot() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { uppdateraKorgAntal(c.item_count); });
      })
      .catch(function () { avisera('Något gick fel. Försök igen.'); })
      .finally(function () { knapp.disabled = false; knapp.textContent = text; });
  }

  function korgformular() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      var knapp = form.querySelector('[type="submit"]');
      if (!knapp) return;
      e.preventDefault();
      laggIKorg(form, knapp);
    });
  }

  function aldersgrans() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-aldersbox]') && e.target.checked) {
        var ruta = e.target.closest('.aldersruta');
        if (ruta) ruta.classList.remove('aldersruta--markerad');
      }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      var box = form.querySelector('[data-aldersbox]');
      if (box && !box.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var ruta = form.querySelector('.aldersruta');
        if (ruta) ruta.classList.add('aldersruta--markerad');
        box.focus();
        avisera('Bekräfta köpvillkoret innan du lägger produkten i varukorgen');
      }
    }, true);
  }

  function begransaAntal(falt) {
    if (!falt) return;
    var min = parseInt(falt.min, 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(falt.max, 10);
    var v = parseInt(falt.value, 10);
    if (isNaN(v)) v = min;
    if (!isNaN(max)) v = Math.min(max, v);
    v = Math.max(min, v);
    falt.value = v;
  }

  function synkaStegare(falt) {
    if (!falt) return;
    var steg = falt.closest('.stegare');
    if (!steg) return;
    var ner = steg.querySelector('[data-steg="ner"]');
    var upp = steg.querySelector('[data-steg="upp"]');
    var min = parseInt(falt.min, 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(falt.max, 10);
    var v = parseInt(falt.value, 10);
    if (isNaN(v)) v = min;
    if (ner) ner.disabled = !!falt.disabled || v <= min;
    if (upp) upp.disabled = !!falt.disabled || (!isNaN(max) && v >= max);
  }

  function stegare() {
    var korgKorrigerad = false;
    document.querySelectorAll('.stegare input[type="number"]').forEach(function (falt) {
      var fore = falt.value;
      begransaAntal(falt);
      synkaStegare(falt);
      if (falt.name === 'updates[]' && falt.value !== fore) korgKorrigerad = true;
    });

    if (korgKorrigerad) {
      var korgForm = document.querySelector('form[action*="/cart"]');
      var uppdateraKnapp = korgForm && korgForm.querySelector('button[name="update"]');
      if (korgForm) {
        if (korgForm.requestSubmit && uppdateraKnapp) korgForm.requestSubmit(uppdateraKnapp);
        else korgForm.submit();
        return;
      }
    }

    document.addEventListener('click', function (e) {
      var knapp = e.target.closest('[data-steg]');
      if (!knapp || knapp.disabled) return;
      var falt = knapp.parentElement.querySelector('input[type="number"]');
      if (!falt || falt.disabled) return;
      var v = parseInt(falt.value, 10);
      if (isNaN(v)) v = parseInt(falt.min, 10) || 0;
      falt.value = knapp.dataset.steg === 'upp' ? v + 1 : v - 1;
      begransaAntal(falt);
      synkaStegare(falt);
      falt.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('input', function (e) {
      var falt = e.target.closest('.stegare input[type="number"]');
      if (!falt) return;
      synkaStegare(falt);
    });

    document.addEventListener('change', function (e) {
      var falt = e.target.closest('.stegare input[type="number"]');
      if (!falt) return;
      begransaAntal(falt);
      synkaStegare(falt);
    });

    document.addEventListener('submit', function (e) {
      e.target.querySelectorAll('.stegare input[type="number"]').forEach(function (falt) {
        begransaAntal(falt);
        synkaStegare(falt);
      });
    }, true);
  }

  function uppdateraSpecRad(rad, cell, varde) {
    if (!rad || !cell) return;
    cell.textContent = varde || '';
    rad.hidden = !varde;
  }

  function varianter() {
    var valj = document.querySelector('[data-variantvalj]');
    if (!valj) return;
    function uppdatera() {
      var vald = valj.options[valj.selectedIndex];
      if (!vald) return;
      var tillg = vald.dataset.tillganglig === 'true';
      var lagerstyrd = vald.dataset.lagerstyrd === 'true';
      var lagerantal = parseInt(vald.dataset.lagerantal, 10);
      var kanLaggaTill = tillg && (!lagerstyrd || (!isNaN(lagerantal) && lagerantal > 0));
      var antal = document.querySelector('#Produktform input[name="quantity"]');
      if (antal) {
        if (lagerstyrd && !isNaN(lagerantal)) {
          if (lagerantal > 0) {
            antal.disabled = false;
            antal.min = '1';
            antal.max = String(lagerantal);
            begransaAntal(antal);
          } else {
            antal.disabled = true;
            antal.removeAttribute('max');
          }
        } else {
          antal.disabled = false;
          antal.min = '1';
          antal.removeAttribute('max');
          begransaAntal(antal);
        }
        synkaStegare(antal);
      }
      var pris = document.querySelector('[data-pris]');
      var jamfor = document.querySelector('[data-jamforpris]');
      var lager = document.querySelector('[data-lager]');
      var kop = document.querySelector('[data-kopknapp]');
      var sPris = document.querySelector('[data-sticky-pris]');
      var sKnapp = document.querySelector('[data-sticky-knapp]');

      if (pris) pris.textContent = vald.dataset.pris || '';
      if (sPris) sPris.textContent = vald.dataset.pris || '';
      if (jamfor) { jamfor.textContent = vald.dataset.jamforpris || ''; jamfor.hidden = !vald.dataset.jamforpris; }
      if (lager) {
        lager.className = 'lagerstatus' + (tillg ? '' : ' lagerstatus--slut');
        lager.innerHTML = '<i aria-hidden="true"></i>' + (tillg ? 'I lager' : 'Tillfälligt slut');
      }
      [kop, sKnapp].forEach(function (k) {
        if (k) {
          k.disabled = !kanLaggaTill;
          k.textContent = kanLaggaTill ? 'Lägg i varukorgen' : (tillg ? 'Maxantal i varukorgen' : 'Tillfälligt slut');
        }
      });
      uppdateraSpecRad(document.querySelector('[data-spec-sku]'), document.querySelector('[data-sku]'), vald.dataset.sku || '');
      uppdateraSpecRad(document.querySelector('[data-spec-gtin]'), document.querySelector('[data-gtin]'), vald.dataset.gtin || '');
      if (vald.dataset.url) history.replaceState({}, '', vald.dataset.url);
    }
    valj.addEventListener('change', uppdatera);
    uppdatera();
  }

  function sticky() {
    var kopruta = document.querySelector('[data-kopruta]');
    var falt = document.querySelector('[data-sticky]');
    if (!kopruta || !falt) return;

    function sattSticky(visa) {
      falt.classList.toggle('synlig', visa);
      document.body.classList.toggle('har-sticky', visa);
    }

    if (!('IntersectionObserver' in window)) {
      falt.hidden = true;
      document.body.classList.remove('har-sticky');
      return;
    }

    var observer = new IntersectionObserver(function (poster) {
      var post = poster[0];
      var visa = window.innerWidth <= 900 && !post.isIntersecting && post.boundingClientRect.top < 0;
      sattSticky(visa);
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(kopruta);

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) sattSticky(false);
    });

    var knapp = falt.querySelector('[data-sticky-knapp]');
    if (knapp) knapp.addEventListener('click', function () {
      if (knapp.disabled) return;
      var form = document.getElementById('Produktform');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  function galleri() {
    var huvud = document.getElementById('Huvudbild');
    var knappar = document.querySelectorAll('[data-miniatyr]');
    if (!huvud || !knappar.length) return;
    knappar.forEach(function (k) {
      k.addEventListener('click', function () {
        huvud.src = k.dataset.miniatyr;
        huvud.srcset = '';
        var miniatyrbild = k.querySelector('img');
        if (miniatyrbild && miniatyrbild.alt) huvud.alt = miniatyrbild.alt;
        knappar.forEach(function (o) {
          o.setAttribute('aria-pressed', o === k ? 'true' : 'false');
          o.classList.toggle('miniatyr--vald', o === k);
        });
      });
    });
  }

  function filter() {
    var form = document.querySelector('[data-filterform]');
    if (form) form.addEventListener('change', function () { form.submit(); });

    var panel = document.querySelector('[data-filterpanel]');
    var oppna = document.querySelector('[data-oppnafilter]');
    var stang = document.querySelector('[data-stangfilter]');
    var fokusFore = null;

    function fokusbara() {
      if (!panel) return [];
      return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function stangPanel(aterfokusera) {
      if (!panel) return;
      panel.classList.remove('oppen');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      document.body.style.overflow = '';
      if (oppna) oppna.setAttribute('aria-expanded', 'false');
      if (aterfokusera !== false && fokusFore && typeof fokusFore.focus === 'function') fokusFore.focus();
    }

    if (oppna && panel) oppna.addEventListener('click', function () {
      fokusFore = document.activeElement;
      panel.classList.add('oppen');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
      oppna.setAttribute('aria-expanded', 'true');
      var fokus = fokusbara()[0];
      if (fokus) fokus.focus(); else panel.focus();
    });

    if (stang) stang.addEventListener('click', function () { stangPanel(true); });

    if (panel) panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !panel.classList.contains('oppen')) return;
      var lista = fokusbara();
      if (!lista.length) { e.preventDefault(); panel.focus(); return; }
      var forsta = lista[0];
      var sista = lista[lista.length - 1];
      if (e.shiftKey && document.activeElement === forsta) { e.preventDefault(); sista.focus(); }
      else if (!e.shiftKey && document.activeElement === sista) { e.preventDefault(); forsta.focus(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('oppen')) stangPanel(true);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && panel && panel.classList.contains('oppen')) stangPanel(false);
    });

    var sortering = document.querySelector('[data-sortering]');
    if (sortering) sortering.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortering.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sidhuvud();
    korgformular();
    aldersgrans();
    stegare();
    varianter();
    sticky();
    galleri();
    filter();
  });
})();
